import styled from 'styled-components';

export const GraphSkeletonStyled = styled.div`
  .body_skeleton {
    height: ${({ height }) => height ? height : '374px'};
  }
`;
